import * as yup from "yup";
import { ObjectShape } from "yup/lib/object";


export const createAgentValidationSchema = (params: { translate: any }) => {
  const { translate } = params;

  const additions = {
    agentId: yup.string().required(translate("youMustEnterAAgentId")),
    website: yup.string().required(translate("youMustEnterAWebsite")),
    established: yup.string().optional().nullable(),
    status: yup.string().required(translate("youMustEnterAStatus")),
    entity: yup.string().required(translate("youMustEnterAnEntityName")),
    registrationNumber: yup.string().optional().nullable(),
    timezone: yup.string().optional().nullable(),
  } as ObjectShape;

  const schema = yup.object().shape(additions);

  return schema;
}
